import {useEffect, useState} from "react";
import MainLink from "../../Link";
const CharacterSelect = ({setHeight, onSelect}) => {
    const [characters, setCharacters] = useState([]);
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const ucp_get_characters = `${MainLink()}api/ucp/get-user-characters`;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userId = localStorage.getItem("user-id");
                const userName = localStorage.getItem("user-login");
                const userPassword = localStorage.getItem("user-password");

                const response = await fetch(ucp_get_characters, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                    body: JSON.stringify({
                        "user_id": userId,
                        "user_name": userName,
                        "user_password": userPassword,
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                setCharacters(result.characters || []);
                if (result.characters.length > 0) {
                    setSelectedCharacter(result.characters[0]);
                    onSelect(result.characters[0]); // Передаём выбранного персонажа в родительский компонент
                }
            } catch (err) {
                console.error("Ошибка загрузки данных:", err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleSelect = (character) => {
        setSelectedCharacter(character);
        onSelect(character); // Отправляем выбранного персонажа в родительский компонент
        setIsOpen(false);
    };

    return (
            <div className={`character-select-container ${isOpen ? "open" : "close"}`}>
                <div className="select-trigger" onClick={toggleDropdown}>
                    <span>{selectedCharacter ? selectedCharacter.name : "Выберите персонажа"}</span>
                    <span className="select-icon">⌄</span>
                </div>
                    <div className="select-content">
                        {characters.map((character, index) => (
                            <div key={index} className="select-item" onClick={() => handleSelect(character)}>
                                {character.name}
                            </div>
                        ))}
                    </div>
            </div>
    );
};

export default CharacterSelect;